var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgTreeFolderIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2 2.5V9.5H10V3.5H5.7929L4.79289 2.5H2ZM6.2071 2.5H10.5C10.7761 2.5 11 2.72386 11 3V10C11 10.2761 10.7761 10.5 10.5 10.5H1.5C1.22386 10.5 1 10.2761 1 10V2C1 1.72386 1.22386 1.5 1.5 1.5H5.2071L6.2071 2.5Z",
  fill: "#2F2F2F"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTreeFolderIcon, _extends({
  svgRef: ref
}, props)));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIgMi41VjkuNUgxMFYzLjVINS43OTI5TDQuNzkyODkgMi41SDJaTTYuMjA3MSAyLjVIMTAuNUMxMC43NzYxIDIuNSAxMSAyLjcyMzg2IDExIDNWMTBDMTEgMTAuMjc2MSAxMC43NzYxIDEwLjUgMTAuNSAxMC41SDEuNUMxLjIyMzg2IDEwLjUgMSAxMC4yNzYxIDEgMTBWMkMxIDEuNzIzODYgMS4yMjM4NiAxLjUgMS41IDEuNUg1LjIwNzFMNi4yMDcxIDIuNVoiIGZpbGw9IiMyRjJGMkYiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };